export default __webpack_public_path__ + "static/media/right.de65e162.svg";